import { connector } from '@env/environment';

export const languageList = [{ title: 'English', value: 'en' }];

export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const TOKEN_TYPE = 'token_type';

export const TOKEN_EXCLUDE_URLS: string[] = ['assets/i18n', connector, 'version.json'];
export const TOKEN_ERROR_SKIP_URLS: string[] = ['api/external-manual-quotes'];
